import axios from './axios-auth';
const getUploads = ({ current, pageSize, viewAllUploads }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/hr-adm/getbatchpointuploadfiles?pg_num=${current}&pg_size=${pageSize}&viewAllUploads=${viewAllUploads}`,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching authorized clients api');
      });
  });
const getAuthorizedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/getauthorizedclients',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching authorized clients api');
      });
  });

const getTemplate = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/hr-adm/downloadfile?ft=pointuploadbatch',
      method: 'GET',
      responseType: 'blob',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching authorized clients api');
      });
  });

const uploadPointsFile = (file, allowDups = false) => {
  const fileFormData = new FormData();
  fileFormData.append('batchfile', file);
  return new Promise(async (resolve, reject) => {
    try {
      const uploadResponse = await axios.post(`/hr-adm/uploadbatchuserpoints?allowDups=${allowDups}`, fileFormData);
      if (uploadResponse.status === 200) {
        const { data } = await axios.get(`/hr-adm/getuploadedbatchuserpoints?batchPointUploadId=${uploadResponse.data}`);
        resolve({ ...data });
      } else {
        reject(uploadResponse.data.message);
      }
    } catch {
      console.log('error while response in batch user points api');
    }
  });
};

const deleteTemplate = (id) =>
  new Promise((resolve, reject) => {
    axios
      .delete(`/hr-adm/deletebatchuserpoints?batchPointUploadId=${id}`)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while response in batch user points api');
      });
  });

const savePointsUploadFile = ({ id, usersToUnlock, createBatchUserPoints }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const uploadResponse = await axios.put('/hr-adm/updatebatchuserpoints', {
        batchPointUploadId: id,
        usersToUnlock: usersToUnlock,
        usersToCreateBatchUserPoints: createBatchUserPoints,
      });
      console.log(uploadResponse);
      const { data } = await axios.post(`/hr-adm/savebatchuserpoints?batchPointUploadId=${id}`);
      resolve({ ...data });
    } catch {
      console.log('error while response in batch user points api');
    }
  });
};

export { getUploads, getAuthorizedClients, getTemplate, uploadPointsFile, deleteTemplate, savePointsUploadFile };
